import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '../../context/CurrentUserContext';
import { getDefaultRouteForRole, isSalesOnly } from '../../utils/routeAccess';

interface SalesOnlyRedirectProps {
  children: React.ReactNode;
}

/**
 * Sends a sales-only user on to their default page (/crm/partner-enquiries) instead of rendering
 * `children`, with no toast: it covers /test-auth's /dashboard, stale links and typed URLs
 * (YOJO-3371 [care-portal CRM page for partner enquiries]). Every other role, and the moment
 * while roles are still loading, renders `children` untouched.
 */
const SalesOnlyRedirect: React.FC<SalesOnlyRedirectProps> = ({ children }) => {
  const { roles, loading } = useCurrentUser();

  if (!loading && isSalesOnly(roles)) {
    return <Navigate to={getDefaultRouteForRole(roles)} replace />;
  }

  return <>{children}</>;
};

export default SalesOnlyRedirect;
